import { TableProps } from 'antd/es/table/InternalTable';
import { Discount } from 'types/data';

export const DiscountTableProps: TableProps<Discount> = {
  bordered: false,
  size: 'large',
  showHeader: true,
  tableLayout: 'auto',
  pagination: false,
  scroll: { x: '100vw' },
  rowSelection: {},
};
